import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class UserSettingsDB extends GenericDB {
  constructor(userId = null) {
    super('', 'users.userSettings');
    this.setUserId(userId);
  }

  setUserId(userId) {
    this.userId = userId;
  }

  getCollectionRef() {
    return collection(db, 'users', this.userId, 'userSettings');
  }
}
